/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
} from './BedType';

/**
 * 
 * @export
 * @interface BulkUpdateBedTypesRequest
 */
export interface BulkUpdateBedTypesRequest {
    /**
     * 
     * @type {Array<BedType>}
     * @memberof BulkUpdateBedTypesRequest
     */
    bed_types: Array<BedType>;
}

/**
 * Check if a given object implements the BulkUpdateBedTypesRequest interface.
 */
export function instanceOfBulkUpdateBedTypesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bed_types" in value;

    return isInstance;
}

export function BulkUpdateBedTypesRequestFromJSON(json: any): BulkUpdateBedTypesRequest {
    return BulkUpdateBedTypesRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedTypesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedTypesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bed_types': ((json['bed_types'] as Array<any>).map(BedTypeFromJSON)),
    };
}

export function BulkUpdateBedTypesRequestToJSON(value?: BulkUpdateBedTypesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bed_types': ((value.bed_types as Array<any>).map(BedTypeToJSON)),
    };
}

